export * from './nfoldProduct';
export * from './types';
export * from './configurations';
export * from './foldConfigurationFactory';

export * from './types2';
export * from './nfoldProduct2';